import * as React from "react";
import { connect } from "react-redux";
import styles from "./seek/Seek.css";

export const Seek = connect((state) => {
  return { teal: state.playerOptions.controls === 2 };
})((props) => (
  <div className={styles.root}>
    {props.direction === "forward" ? (
      <span className="icon-SeekForward" />
    ) : (
      <span className="icon-SeekBackward" />
    )}
  </div>
));
